import React, { useState } from 'react'
import Toggle from '../../../../../Toggle'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import AlarmConfigBox from './AlarmConfigBox'
import { cloneDeepAlarmsProps } from '../../../../../../../cloneDeepFunctions'
interface Props {
    showAlarmConfigs?: boolean
    alarms: AlarmsProps
    onChange: (configKey: string, newValue: boolean | AlarmsProps) => void
}

export default function AlarmConfigsContainer(props: Props): React.ReactElement {
    const alarms: AlarmsProps = cloneDeepAlarmsProps(props.alarms) ?? {
        configured: {
            background: '',
            iconColor: 'green',
            icon: 'check'
        },
        warning: {
            background: '#E6E600',
            iconColor: '#E6E600',
            icon: 'exclamation',
            blink: 1000
        },
        critical: {
            background: '#CC2900',
            iconColor: '#CC2900',
            icon: 'exclamation',
            blink: 1000
        },
        notMapped: {
            background: 'blue',
            iconColor: 'blue',
            icon: 'times'
        }
    }
    const [show, setShow] = useState(props.showAlarmConfigs ?? false)
    const changeChannelAlarms = (configField: string, newValue: AlarmConfigs): void => {
        const newAlarms: AlarmsProps = cloneDeepAlarmsProps(alarms)
        newAlarms[configField] = { ...newValue }
        props.onChange('alarms', newAlarms)
    }

    return (
        <ConfigsContainer>
            <Toggle
                label={i18n('Custom alarm styles')}
                value={show}
                configKey={'showAlarmConfigs'}
                onChange={(configKey: string, newValue: boolean) => {
                    setShow(newValue)
                    props.onChange(configKey, newValue)
                }}
            />
            {show && (
                <>
                    <AlarmConfigBox
                        label={i18n('Critical')}
                        configKey={'critical'}
                        configs={alarms.critical}
                        onChange={changeChannelAlarms}
                    />
                    <AlarmConfigBox
                        label={i18n('Warning')}
                        configKey={'warning'}
                        configs={alarms.warning}
                        onChange={changeChannelAlarms}
                    />
                    <AlarmConfigBox
                        label={i18n('Configured')}
                        configKey={'configured'}
                        configs={alarms.configured}
                        onChange={changeChannelAlarms}
                    />
                    <AlarmConfigBox
                        label={i18n('Not mapped')}
                        configKey={'notMapped'}
                        configs={alarms.notMapped}
                        onChange={changeChannelAlarms}
                    />
                </>
            )}
        </ConfigsContainer>
    )
}

const ConfigsContainer = styled.div`
    padding: 7px 11px 11px;
`
